import { getCurrentUserAccountEmail } from "./authService";

const userPrefsStorageKey = "userPrefs";




export interface IStoredUserPrefs {
  lastUpdatedOn: Date;
  email: string;
  tenantInstallationId: string;
}

function getAllUserPrefs() {
  const json = String(localStorage.getItem(userPrefsStorageKey));
  const prefs = (JSON.parse(json) || [])
    .map((p: IStoredUserPrefs) => {p.lastUpdatedOn = new Date(p.lastUpdatedOn); return p; });
  return prefs as IStoredUserPrefs[];
}

export function getCurrentUserPrefs(email = getCurrentUserAccountEmail()) {
  if (!email) {
    return undefined;
  }

  const prefs = getAllUserPrefs().find(p => p.email === email);
  return prefs;
}

export function updateCurrentUserPrefs(prefs: Omit<IStoredUserPrefs, "email" | "lastUpdatedOn">, email = getCurrentUserAccountEmail()) {
  if (!email) {
    return undefined;
  }

  let allPrefs = getAllUserPrefs();
  const index = allPrefs.findIndex(p => p.email.toLocaleLowerCase() === email);
  const storedPrefs = index > -1 ? allPrefs[index] : {}
  const updatedPrefs: IStoredUserPrefs = { ...storedPrefs, ...prefs, email, lastUpdatedOn: new Date() };
  if (index > -1) {
    allPrefs[index] = updatedPrefs;
  }
  else {
    allPrefs = [updatedPrefs, ...allPrefs];
  }

  allPrefs.sort((p1, p2) => p2.lastUpdatedOn.valueOf() - p1.lastUpdatedOn.valueOf());
  localStorage.setItem(userPrefsStorageKey, JSON.stringify(allPrefs));
  return updatedPrefs;
}
